import React, { Component } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import RadioConditional from "../../components/RadioConditional";
import RadioQuestion from "../../components/RadioQuestion";
import TextQuestion from "../../components/TextQuestion";
import ScrollToTop from "../../components/utils/ScrollToTop";
import { YES_NO_OPTIONS } from "../../constants";
import { isEmailValid } from "../../shared/utils/validation";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";

class BuyingEstateAgent extends Component {
  constructor(props) {
    super(props);

    const errorMessages = {
      hasEstateAgent: "Let us know if you have an estate agent",
      estateAgent: {
        name: "Enter their full name",
        emailAddress: "Enter the email address",
        phoneNumber: "Enter the phone number",
      },
      sellerFullName: "Enter their full name",
      sellerEmailAddress: "Enter their email address",
      sellerPhoneNumber: "Enter their phone number",
    };

    if (this.props.buyingEstateAgent) {
      const ea = this.props.buyingEstateAgent;

      this.state = {
        hasEstateAgent: ea.hasEstateAgent,
        estateAgent: { ...ea.estateAgent },
        sellerFullName: ea.sellerFullName,
        sellerEmailAddress: ea.sellerEmailAddress,
        sellerPhoneNumber: ea.sellerPhoneNumber,
        errors: {},
        errorMessages: errorMessages,
      };
    } else {
      this.state = {
        hasEstateAgent: null,
        estateAgent: {
          name: "",
          emailAddress: "",
          phoneNumber: "",
        },
        sellerFullName: "",
        sellerEmailAddress: "",
        sellerPhoneNumber: "",
        errors: {},
        errorMessages: errorMessages,
      };
    }
  }

  handleValidation() {
    const fields = { ...this.state };
    const estateAgentFields = { ...this.state.estateAgent };
    const errorMessages = { ...this.state.errorMessages };

    let errors = {};
    let formIsValid = true;

    if (fields["hasEstateAgent"] === null) {
      const field = "hasEstateAgent";
      formIsValid = false;
      errors[field] = errorMessages[field];
    }

    if (fields["hasEstateAgent"] === true) {
      if (!estateAgentFields["name"]) {
        const field = "name";
        formIsValid = false;
        errors[field] = errorMessages.estateAgent[field];
      }
      if (!estateAgentFields["emailAddress"]) {
        const field = "emailAddress";
        formIsValid = false;
        errors[field] = errorMessages.estateAgent[field];
      }
      if (estateAgentFields["emailAddress"] && !isEmailValid(estateAgentFields["emailAddress"])) {
        formIsValid = false;
        errors["emailAddress"] = "Please enter a valid email address";
      }
      if (!estateAgentFields["phoneNumber"]) {
        const field = "phoneNumber";
        formIsValid = false;
        errors[field] = errorMessages.estateAgent[field];
      }
    }

    if (fields["hasEstateAgent"] === false) {
      if (!fields["sellerFullName"]) {
        const field = "sellerFullName";
        formIsValid = false;
        errors[field] = errorMessages[field];
      }
      if (!fields["sellerEmailAddress"]) {
        const field = "sellerEmailAddress";
        formIsValid = false;
        errors[field] = errorMessages[field];
      }
      if (fields["sellerEmailAddress"] && !isEmailValid(fields["sellerEmailAddress"])) {
        formIsValid = false;
        errors["sellerEmailAddress"] = "Please enter a valid email address";
      }
      if (!fields["sellerPhoneNumber"]) {
        const field = "sellerPhoneNumber";
        formIsValid = false;
        errors[field] = errorMessages[field];
      }
    }

    this.setState({ errors });
    return formIsValid;
  }

  handleFieldValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    this.setState((prevState) => {
      let errors = { ...prevState.errors };
      const errorMessages = { ...prevState.errorMessages };

      if (!isBlur) {
        errors[field] = null;
      } else {
        if (!prevState[field]) {
          errors[field] = errorMessages[field];
        }
        if (field === "sellerEmailAddress" && prevState[field] && !isEmailValid(prevState[field])) {
          errors[field] = "Please enter a valid email address";
        }
      }
      return { errors };
    });
  };

  handleEstateAgentFieldValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    this.setState((prevState) => {
      let errors = { ...prevState.errors };
      const errorMessages = { ...prevState.errorMessages };

      if (!isBlur) {
        errors[field] = null;
      } else {
        if (!prevState.estateAgent[field]) {
          errors[field] = errorMessages.estateAgent[field];
        }
        if (field === "emailAddress" && prevState.estateAgent[field] && !isEmailValid(prevState.estateAgent[field])) {
          errors[field] = "Please enter a valid email address";
        }
      }
      return { errors };
    });
  };

  selectHasEstateAgent = (ea) => {
    this.setState({ hasEstateAgent: ea });
  };

  handleEstateAgentChange = (field) => (event) => {
    let estateAgent = { ...this.state.estateAgent };
    estateAgent[field] = event;
    this.setState({ estateAgent });
  };

  sellerFullNameEntered = (sfn) => {
    this.setState({ sellerFullName: sfn });
  };

  sellerEmailAddressEntered = (sea) => {
    this.setState({ sellerEmailAddress: sea });
  };

  sellerPhoneNumberEntered = (spn) => {
    this.setState({ sellerPhoneNumber: spn });
  };

  saveBuyingEstateAgent = (event) => {
    event.preventDefault();
    if (this.handleValidation()) {
      this.props.onStepComplete({
        buyingEstateAgent: {
          hasEstateAgent: this.state.hasEstateAgent,
          estateAgent: this.state.estateAgent,
          sellerFullName: this.state.sellerFullName,
          sellerEmailAddress: this.state.sellerEmailAddress,
          sellerPhoneNumber: this.state.sellerPhoneNumber,
        },
      });
      return;
    }
  };

  render() {
    return (
      <React.Fragment>
        <ScrollToTop />
        <Card title="Tell us if you’re using an estate agent" removeTopPadding>
          <RadioQuestion
            question="Are you buying through an estate agent?"
            options={YES_NO_OPTIONS}
            inline={true}
            name="estateAgent"
            selected={this.state.hasEstateAgent}
            optionSelected={this.selectHasEstateAgent}
            validate={this.handleFieldValidation("hasEstateAgent")}
            validationError={this.state.errors.hasEstateAgent ? this.state.errors.hasEstateAgent : null}
          />

          {this.state.hasEstateAgent && (
            <RadioConditional>
              <p>Great, we'll get in touch with them to introduce ourselves.</p>

              <TextQuestion
                question="Who’s handling your purchase?"
                hint="If there’s more than one person, who do you speak to the most?"
                value={this.state.estateAgent.name || ""}
                valueEntered={this.handleEstateAgentChange("name")}
                validate={this.handleEstateAgentFieldValidation("name")}
                validationError={this.state.errors.name ? this.state.errors.name : null}
              />
              <TextQuestion
                question="What’s their email address?"
                inputMode="email"
                value={this.state.estateAgent.emailAddress || ""}
                valueEntered={this.handleEstateAgentChange("emailAddress")}
                validate={this.handleEstateAgentFieldValidation("emailAddress")}
                validationError={this.state.errors.emailAddress ? this.state.errors.emailAddress : null}
              />
              <TextQuestion
                question="What’s their phone number?"
                type="tel"
                value={this.state.estateAgent.phoneNumber || ""}
                valueEntered={this.handleEstateAgentChange("phoneNumber")}
                validate={this.handleEstateAgentFieldValidation("phoneNumber")}
                validationError={this.state.errors.phoneNumber ? this.state.errors.phoneNumber : null}
              />
            </RadioConditional>
          )}

          {this.state.hasEstateAgent === false && (
            <RadioConditional>
              <p>In that case, we’ll get in touch with the seller directly to introduce ourselves</p>

              <TextQuestion
                question="What’s the seller’s name?"
                value={this.state.sellerFullName}
                valueEntered={this.sellerFullNameEntered}
                validate={this.handleFieldValidation("sellerFullName")}
                validationError={this.state.errors.sellerFullName ? this.state.errors.sellerFullName : null}
              />

              <TextQuestion
                question="What’s their email address?"
                inputMode="email"
                value={this.state.sellerEmailAddress}
                valueEntered={this.sellerEmailAddressEntered}
                validate={this.handleFieldValidation("sellerEmailAddress")}
                validationError={this.state.errors.sellerEmailAddress ? this.state.errors.sellerEmailAddress : null}
              />

              <TextQuestion
                question="What’s their phone number?"
                type="tel"
                value={this.state.sellerPhoneNumber}
                valueEntered={this.sellerPhoneNumberEntered}
                validate={this.handleFieldValidation("sellerPhoneNumber")}
                validationError={this.state.errors.sellerPhoneNumber ? this.state.errors.sellerPhoneNumber : null}
              />
            </RadioConditional>
          )}

          <Action onClick={this.saveBuyingEstateAgent}>Continue</Action>
        </Card>
        <Image src={imageCatAndHousePlant} />
      </React.Fragment>
    );
  }
}

export default BuyingEstateAgent;
